import {
  CheckCircleOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined,
  ProjectOutlined,
  RocketOutlined,
} from "@ant-design/icons";
import { Card, Col, Row, Spin, Statistic } from "antd";
import { useState } from "react";
import { useGetProductionProjectOverview } from "../../query/ProductionQuery";

interface ProductionProjectOverviewProps {
  onStatusClick?: (status: string) => void;
}

const ProductionProjectOverView = ({
  onStatusClick,
}: ProductionProjectOverviewProps) => {
  const { data, isLoading } = useGetProductionProjectOverview();
  const [selectedStatus, setSelectedStatus] = useState<string>();

  const handleStatusClick = (status: string) => {
    setSelectedStatus(status);
    onStatusClick?.(status);
  };

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spin size="large" />
      </div>
    );
  }

  const colProps = {
    xs: 24,
    md: 12,
    lg: 8,
    xl: 4,
  };

  return (
    <Row gutter={[16, 16]}>
      <Col {...colProps}>
        <Card
          className={`shadow-md bg-gradient-to-r from-blue-500 to-blue-600 cursor-pointer ${
            selectedStatus === "" ? "border border-blue-800" : ""
          }`}
          onClick={() => handleStatusClick("")}
        >
          <Statistic
            title={<span className="text-white font-semibold">Tổng dự án</span>}
            value={data?.total || 0}
            prefix={<ProjectOutlined className="text-white" />}
            valueStyle={{ color: "#fff" }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card
          className={`cursor-pointer hover:shadow-md transition-all ${
            selectedStatus === "new" ? "border border-green-500" : ""
          }`}
          onClick={() => handleStatusClick("new")}
        >
          <Statistic
            title="Dự án mới"
            value={data?.status.NEW || 0}
            prefix={<RocketOutlined />}
            valueStyle={{ color: "#52c41a" }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card
          className={`cursor-pointer hover:shadow-md transition-all ${
            selectedStatus === "progress" ? "border border-yellow-500" : ""
          }`}
          onClick={() => handleStatusClick("progress")}
        >
          <Statistic
            title="Đang thực hiện"
            value={data?.status.IN_PROGRESS || 0}
            prefix={<ClockCircleOutlined />}
            valueStyle={{ color: "#faad14" }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card
          className={`cursor-pointer hover:shadow-md transition-all ${
            selectedStatus === "done" ? "border border-green-500" : ""
          }`}
          onClick={() => handleStatusClick("done")}
        >
          <Statistic
            title="Hoàn thành"
            value={data?.status.DONE || 0}
            prefix={<CheckCircleOutlined />}
            valueStyle={{ color: "#52c41a" }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card
          className={`cursor-pointer hover:shadow-md transition-all ${
            selectedStatus === "cancel" ? "border border-gray-500" : ""
          }`}
          onClick={() => handleStatusClick("cancel")}
        >
          <Statistic
            title="Đã huỷ"
            value={data?.status.CANCELLED || 0}
            prefix={<CloseCircleOutlined />}
            valueStyle={{ color: "#8c8c8c" }}
          />
        </Card>
      </Col>

      <Col {...colProps}>
        <Card
          className={`cursor-pointer hover:shadow-md transition-all ${
            selectedStatus === "overdue" ? "border border-red-500" : ""
          }`}
          onClick={() => handleStatusClick("overdue")}
        >
          <Statistic
            title={<span className="text-red-600 font-semibold">Quá hạn</span>}
            value={data?.overDue || 0}
            prefix={<ExclamationCircleOutlined />}
            valueStyle={{ color: "#ff4d4f" }}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default ProductionProjectOverView;
